const isCssVariable = (value) => (typeof value === 'string' && value.startsWith('--'));
const setElementCssVariable = ({ element, name, value, }) => {
    if (!isCssVariable(name)) {
        return;
    }
    element.style.setProperty(name, value);
};

export { isCssVariable, setElementCssVariable };
//# sourceMappingURL=index.js.map
